import React from "react";
import { ButtonGroup, Button } from "reactstrap";

const defaultRanges = [
  { label: "All", value: 5 },
  { label: "1 Day", value: 1 },
  { label: "7 Days", value: 2 },
  { label: "1 Month", value: 3 },
  { label: "1 Year", value: 4 },
];

const TimeRangeFilter = ({
  value,
  onChange,
  ranges = defaultRanges,
}) => {
  return (
    <ButtonGroup className="bg-light p-1 rounded-pill">
      {ranges.map((range) => {
        const isActive = value === range.value;

        return (
          <Button
            key={range.value}
            size="sm"
            onClick={() => onChange(range.value)}
            className="rounded-pill px-3 fw-medium border-0"
            style={{
              backgroundColor: isActive ? "#f79400" : "transparent",
              borderColor: "#f79400",
              color: isActive ? "#000" : "#6c757d",
              opacity: isActive ? 1 : 0.85,
              textTransform: "capitalize",
              transition: "all 0.2s ease",
              fontWeight: isActive ? 600 : 500,
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = "#f79400";
                e.currentTarget.style.color = "#fff";
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#6c757d";
              }
            }}
          >
            {range.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default TimeRangeFilter;
